import React, { useEffect, useState } from "react";

import "./FilterCheckbox.css";
import styled from "styled-components";
import { Checkbox } from "antd";
import { useAllContexts } from "../../../hooks/useAllContexts";

const MapFilters = ({
  isAmea = false,
  categoryId,
  selectedCategory,
  refreshMap,
}) => {
  const { meteo, ameaInfrastructures, sensorTypes, allSensors } =
    useAllContexts();
  const [filters, setFilters] = useState(null);
  const [refreshComponent, setRefreshComponent] = useState(false);

  useEffect(() => {
    setFilters(
      categoryId === "5"
        ? meteo?.meteoInfoFilters
        : categoryId === "31"
        ? allSensors?.allSensorsData && allSensors.allSensorsData[31].filters
        : categoryId === "122"
        ? selectedCategory === "infra"
          ? ameaInfrastructures?.infrastructureFilters
          : null
        : null
    );
  }, [filters, refreshComponent, ameaInfrastructures?.infrastructureFilters]);

  const handleAmeaFilterChange = (filterId, filterValue) => {
    if (selectedCategory === "infra") {
      ameaInfrastructures.handleInfrastructureFilterChange(
        filterId,
        filterValue
      );
    }
    setRefreshComponent(!refreshComponent);
    refreshMap();
  };

  return (
    <div
      style={{
        maxWidth: "450px",
        maxHeight: "300px",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "20px",
        paddingInline: "10px",
      }}
    >
      {isAmea && (
        <div
          style={{
            display: "flex",

            flexWrap: "wrap",
            gap: "40px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <p>Κατηγορία</p>
            {filters
              ?.filter((filter) => filter.type === "category")
              .map((item) => {
                return (
                  <FilterCheckBox
                    key={`filter_category_${item.typeId}`}
                    defaultChecked={item.isActive}
                    onChange={(event) => {
                      handleAmeaFilterChange(
                        item?.typeId,
                        event.target.checked
                      );
                    }}
                  >
                    {item.title}
                  </FilterCheckBox>
                );
              })}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <p>Τύπος</p>
            {filters
              ?.filter((filter) => filter.type === "type")
              .map((item) => {
                return (
                  <FilterCheckBox
                    key={`filter_type_${item.typeId}`}
                    defaultChecked={item.isActive}
                    onChange={(event) => {
                      handleAmeaFilterChange(item.typeId, event.target.checked);
                    }}
                  >
                    {item.title}
                  </FilterCheckBox>
                );
              })}
          </div>
        </div>
      )}
      {!isAmea &&
        filters?.map((filter) => {
          return (
            <FilterCheckBox
              key={`filter_category_${filter.id}`}
              defaultChecked={filter.isActive}
              onChange={(event) => {
                if (categoryId === "5") {
                  meteo.handleMeteoFilterChange(
                    filter.id,
                    event.target.checked
                  );
                }
                refreshMap();
                setRefreshComponent(!refreshComponent);
              }}
            >
              {filter.title}
            </FilterCheckBox>
          );
        })}
    </div>
  );
};

export default MapFilters;

const FilterCheckBox = styled(Checkbox)`
  span {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }
`;
